import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import * as API from '../../Utils/API.js';
import { User } from '../../Types/User';
import Schedule, { Layout } from '../../Components/Schedule';
import StepsNav from '../../Components/Steps';

type Props =
  { interviewerUser: User
  , availability: string[]
  , interviewLengthMinutes: number
  , originalInterviewId: number
  }

enum Step
  { SelectTime
  }

function formatDateTime(date: Date) {
  return date.toLocaleDateString('en-US',{
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short'
  })
}

const RescheduleInterview = (props: Props) => {
  const [currentStep, setCurrentStep] = useState(Step.SelectTime);

  const [selectedDate, setSelectedDate] = useState<Date>(new Date(props.availability[0]));
  const [selectedTime, setSelectedTime] = useState<Date>();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });

    setShowErrors(false);
  }, [currentStep])

  function rescheduleInterview() {
    setIsSubmitting(true);

    const postBody = {
      interviewId: props.originalInterviewId,
      startTimeUtc: selectedTime.toISOString()
    }

    API.post("copilot_interview_reschedule_interview_path", postBody).then(function (result) {
      if (result['error']) {
        if (result['message']) {
          setErrorMessage(result['message'])
        } else {
          setErrorMessage("Something went wrong. Our team has been notified and will investigate the issue.")
        }
      } else {
        window.location.href = result['confirmationPath']
      }
      setIsSubmitting(false);
    })
  }

  const ViewSelectTimePage = () => {
    function handleSelectTime(time: Date) {
      setSelectedTime(time)
    }

    return (
      <div className="card">
        <div className="">
          <div className="card-header border-0 py-2">
            <div className="h2 mb-0 text-dark">Reschedule Interview</div>
            <div>Interview with {props.interviewerUser.firstName} {props.interviewerUser.lastName}</div>
          </div>
          <div className="card-body py-3 border-top border-bottom">
            <h5 className="fw-bold mb-3">Interview length: {props.interviewLengthMinutes} minutes</h5>
            <Schedule
              layout={Layout.Wide}
              availableDateTimes={props.availability}
              selectedDate={selectedDate}
              selectedTime={selectedTime}
              onSelectDate={setSelectedDate}
              onSelectTime={handleSelectTime}
            />
          </div>
          <div className="card-footer d-flex border-0 justify-content-end">
            <button className="btn btn-primary px-6 ms-2 t--confirm-reschedule"
              onClick={rescheduleInterview}
              disabled={!selectedTime || isSubmitting}
            >
                Confirm New Time
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="row justify-content-center" style={{minHeight: '100vh'}}>
      <div className="col-12 col-lg-10 col-xl-9">
          <StepsNav
            numSteps={1}
            currentStepNum={currentStep}
            containerClass="mb-2"
          />
        {(() => {
          switch (currentStep) {
            case Step.SelectTime:
              return ViewSelectTimePage();
            default:
              return null;
          }
        })() as React.ReactNode}
      </div>
    </div>
  )
}

export default RescheduleInterview;
